import React from 'react'
import PropTypes from 'prop-types'

const COPY_PATH = 'M6 12C5.63333 12 5.31944 11.8694 5.05833 11.6083C4.79722 11.3472 4.66667 11.0333 4.66667 '
  + '10.6667V2.66667C4.66667 2.3 4.79722 1.98611 5.05833 1.725C5.31944 1.46389 5.63333 1.33333 6 1.33333'
  + 'H12C12.3667 1.33333 12.6806 1.46389 12.9417 1.725C13.2028 1.98611 13.3333 2.3 13.3333 2.66667V10.6667'
  + 'C13.3333 11.0333 13.2028 11.3472 12.9417 11.6083C12.6806 11.8694 12.3667 12 12 12H6ZM6 10.6667H12'
  + 'V2.66667H6V10.6667ZM3.33333 14.6667C2.96667 14.6667 2.65278 14.5361 2.39167 14.275C2.13056 14.0139 2 '
  + '13.7 2 13.3333V4H3.33333V13.3333H10.6667V14.6667H3.33333Z'

const CopyOutlineIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="currentColor"
    height="1em"
    viewBox="0 0 16 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={COPY_PATH} />
  </svg>
)

CopyOutlineIcon.propTypes = {
  className: PropTypes.string
}

CopyOutlineIcon.defaultProps = {
  className: ''
}

export default CopyOutlineIcon
